<template>
    <div class="page_home_hx flex-col">

        <div class="box_12 flex-col">
            <span class="text_30">核心业务</span>
            <span class="text-wrapper_4">
        自主研发的3C企业健康管理服务体系，深入洞察医药企业上市产品全生命周期的风险与合规管理，助力企业实现可持续发展。
      </span>
            <div class="list_28 flex-row" style="align-items: flex-start; justify-content: center; gap: 1px;margin-top: 25px">
                <div
                        class="section_2 flex-row justify-end"
                        :style="{
          background: item.lanhuBg0,
          height: item.isHovered ? '520px' : '264px'  // 动态高度
        }"
                        v-for="(item, index) in loopData0"
                        :key="index"
                        @mouseover="handleHover(index, true)"
                        @mouseleave="handleHover(index, false)"
                >
                    <div class="box_181 flex-col">
                        <img class="image_9" referrerpolicy="no-referrer" :src="item.lanhuimage0" />
                        <div class="text-wrapper_5">
                            <span class="text_33" v-html="item.lanhutext0"></span>
                            <span class="text_34" v-html="item.lanhutext1"></span>
                        </div>
                        <span class="text_35" v-html="item.lanhutext2"></span>
                        <div class="text-wrapper_6 flex-col"  v-if="!item.isHovered" >
                            <span class="text_36" v-html="item.lanhutext3"  ></span>
                        </div>
                        <div v-if="item.isHovered">
                            <span class="detailInfo" v-html="item.detailInfo" ></span>
                        </div>
                    </div>
                    <img class="image_52" referrerpolicy="no-referrer" :src="item.lanhuimage1" />
                </div>
            </div>
            <div class="image-wrapper_1 flex-col align-center">
                <img
                        class="image_26"
                        referrerpolicy="no-referrer"
                        src="../../../assets/index/chpc_home_index_hx_10.png"
                />
            </div>
        </div>

        <div class="group_179 flex-col">
            <div class="block_3 flex-col">
                <div class="block_93 flex-row">
                    <div class="text-group_356 flex-col justify-between">
                        <span class="text_45">多维度荣誉资质</span>
                        <span class="text_46">康柏汉森已获业内多维度认证与资质，持续为客户创造价值</span>
                    </div>
                </div>
                <div class="block_94 flex-row justify-between">
                    <div class="group_180 flex-col justify-between">
                        <div class="group_181 flex-row">
                            <div class="block_5 flex-row">
                                <div class="image-text_258 flex-col justify-between">
                                    <img
                                            class="image_15"
                                            referrerpolicy="no-referrer"
                                            src="../../../assets/index/chpc_index_honor11.png"
                                    />
                                    <div class="text-group_357 flex-col justify-between">
                                        <span class="text_47">信息安全管理体系认证证书</span>
                                        <span class="text_48">ISO&nbsp;27001</span>
                                    </div>
                                </div>
                            </div>
                            <div class="block_6 flex-row">
                                <div class="image-text_259 flex-col justify-between">
                                    <img
                                            class="image_16"
                                            referrerpolicy="no-referrer"
                                            src="../../../assets/index/chpc_index_honor10.png"
                                    />
                                    <div class="text-group_358 flex-col justify-between">
                                        <span class="text_49">质量管理体系认证证书</span>
                                        <span class="text_50">ISO&nbsp;9001</span>
                                    </div>
                                </div>
                            </div>
                            <!--
                            <div class="block_7 flex-row">
                                <div class="image-text_260 flex-col justify-between">
                                    <div class="image-wrapper_2 flex-col">
                                        <img
                                                class="image_17"
                                                referrerpolicy="no-referrer"
                                                src="../../../assets/index/chpc_index_honor9.png"
                                        />
                                    </div>
                                    <div class="text-group_359 flex-col justify-between">
                                        <span class="text_51">多元化供应商</span>
                                        <span class="text_52">MSD&nbsp;China</span>
                                    </div>
                                </div>
                            </div>
                            -->
                            <div class="box_19 flex-row">
                                <div class="image-text_261 flex-col justify-between">
                                    <div class="image-wrapper_4 flex-col">
                                        <img
                                                class="image_20"
                                                referrerpolicy="no-referrer"
                                                src="../../../assets/index/chpc_index_honor8.png"
                                        />
                                    </div>
                                    <div class="text-group_360 flex-col justify-between">
                                        <span class="text_56">已进行科学碳目标设定</span>
                                        <span class="text-wrapper_11">SBTi</span>
                                    </div>
                                </div>
                            </div>
                            <div class="box_22 flex-col">
                                <img
                                        class="image_21"
                                        referrerpolicy="no-referrer"
                                        src="../../../assets/index/chpc_index_honor4.png"
                                />
                                <div class="text-group_364 flex-col justify-between">
                                    <span class="text_61">&nbsp;24-25获气候问卷B级</span>
                                    <span class="text_62">CDP</span>
                                </div>
                            </div>

                        </div>
                        <div class="group_182 flex-row">
                            <div class="group_25 flex-col">
                                <img
                                        class="image_18"
                                        referrerpolicy="no-referrer"
                                        src="../../../assets/index/chpc_index_honor7.png"
                                />
                                <div class="text-group_361 flex-col justify-between">
                                    <span class="text_53">企业社会责任认证单位</span>
                                    <span class="text_54">EcoVdis</span>
                                </div>
                            </div>
                            <div class="group_26 flex-col">
                                <div class="image-wrapper_3 flex-col">
                                    <img
                                            class="image_19"
                                            referrerpolicy="no-referrer"
                                            src="../../../assets/index/chpc_index_honor6.png"
                                    />
                                </div>
                                <div class="text-group_362 flex-col justify-between">
                                    <span class="text_55">多项自研技术专利</span>
                                    <span class="paragraph_1">
                    Patent
                    <br />
                  </span>
                                </div>
                            </div>
                            <div class="box_20 flex-col">
                                <img
                                        class="image_43"
                                        referrerpolicy="no-referrer"
                                        src="../../../assets/index/chpc_index_honor5.png"
                                />
                                <div class="text-group_363 flex-col justify-between">
                                    <span class="text_59">多个行业委员会成员企业</span>
                                    <span class="text_60">ASSOCIATION</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--
                    <div class="box_22 flex-col">
                        <img
                                class="image_21"
                                referrerpolicy="no-referrer"
                                src="../../../assets/index/chpc_index_honor4.png"
                        />
                        <div class="text-group_364 flex-col justify-between">
                            <span class="text_61">&nbsp;24-25获气候问卷B级</span>
                            <span class="text_62">CDP</span>
                        </div>
                    </div>
                    -->
                </div>
            </div>

            <div class="block_9 flex-row justify-between" ref="serviceAdvantages">
                <div class="text-group_365 flex-col justify-between">
                    <span class="text_63">服务优势</span>
                    <span class="text_64">SERVICE&nbsp;ADVANTAGES</span>
                </div>
                <div class="box_23 flex-col">
                    <div class="section_83 flex-row">
                        <span class="paragraph_2">药械/大健康行业服务经验</span>
                        <span class="text_118">近</span>
                        <span class="text_65">年</span>
                        <div class="box_25 flex-col"></div>
                        <span class="paragraph_3">
              大型药械外企
              <br />
              优选供应商
            </span>
                        <div class="image-text_262 flex-col justify-between">
                            <img
                                    class="label_17"
                                    referrerpolicy="no-referrer"
                                    src="../../../assets/index/chpc_home_count06.png"
                            />
                            <span class="text-group_20">{{serverCount[1]}}+</span>
                        </div>
                        <span class="text_66">家</span>
                        <div class="box_28 flex-col"></div>
                        <div class="image-text_263 flex-col justify-between">
                            <img
                                    class="label_25"
                                    referrerpolicy="no-referrer"
                                    src="../../../assets/index/chpc_home_count05.png"
                            />
                            <span class="text-group_21">{{serverCount[2]}}+</span>
                        </div>
                        <span class="paragraph_4">药械/大健康合作客户</span>
                        <span class="text_67">家</span>
                        <div class="box_30 flex-col"></div>
                        <div class="image-text_264 flex-col justify-between">
                            <img
                                    class="label_18"
                                    referrerpolicy="no-referrer"
                                    src="../../../assets/index/chpc_home_count04.png"
                            />
                            <span class="text-group_22">{{serverCount[3]}}+</span>
                        </div>
                        <span class="paragraph_5">年均可疑<br />商户走访量</span>
                        <span class="text_68">家</span>
                        <div class="image-text_265 flex-col justify-between">
                            <img
                                    class="label_2"
                                    referrerpolicy="no-referrer"
                                    src="../../../assets/index/chpc_home_count03.png"
                            />
                            <span class="text-group_19">{{serverCount[0]}}</span>
                        </div>
                        <div class="image-wrapper_21 flex-row">

                        </div>
                    </div>
                    <div class="section_84 flex-row">
                        <div class="box_182 flex-col justify-between">
                            <div class="group_183 flex-row justify-between">
                                <div class="image-text_269 flex-col justify-between">
                                    <img
                                            class="label_22"
                                            referrerpolicy="no-referrer"
                                            src="../../../assets/index/chpc_index.map_03.png"
                                    />
                                    <span class="text-group_26">{{serverCount[7]}}+</span>
                                </div>
                                <span class="text_73">个</span>
                            </div>
                            <span class="paragraph_9">近3年<br />执行覆盖城市</span>
                        </div>
                        <div class="group_30 flex-col"></div>

                        <div class="box_184 flex-col justify-between">
                            <div class="box_185 flex-row justify-between">
                                <div class="image-text_267 flex-col justify-between">
                                    <img
                                            class="label_20"
                                            referrerpolicy="no-referrer"
                                            src="../../../assets/index/chpc_home_count02.png"
                                    />
                                    <span class="text-group_24">{{serverCount[4]}}+</span>
                                </div>
                                <span class="text_70">份</span>
                            </div>
                            <span class="paragraph_6">年均HCO/CSO/<br />DLR&nbsp;DD报告</span>
                        </div>
                        <div class="group_32 flex-col"></div>

                        <div class="image-text_268 flex-col justify-between">
                            <img
                                    class="label_21"
                                    referrerpolicy="no-referrer"
                                    src="../../../assets/index/chpc_home_count01.png"
                            />
                            <div class="text-group_366 flex-col justify-between">
                                <span class="text_71">{{serverCount[5]}}+</span>
                                <span class="paragraph_7">年均商业<br />及终端执行量</span>
                            </div>
                        </div>
                        <span class="text_72">次</span>

                        <div class="group_33 flex-col"></div>
                        <div class="box_186 flex-col justify-between">
                            <div class="box_183 flex-row justify-between">
                                <div class="image-text_266 flex-col justify-between">
                                    <img
                                            class="label_19"
                                            referrerpolicy="no-referrer"
                                            src="../../../assets/index/chpc_index.map_02.png"
                                    />
                                    <span class="text_71"> {{serverCount[6]}}+ </span>
                                </div>
                                <span class="text_72">  次  </span>
                            </div>
                            <span class="paragraph_8">  近3年<br />走访经销商  </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="box_news_wrap flex-col">
            <div class="block_95 flex-row">
                <div class="text-group_367 flex-col justify-between">
                    <span class="text_74">新闻中心</span>
                    <span class="text_75">NEWS&nbsp;CENTER</span>
                </div>
            </div>
            <div class="block_96 flex-row justify-between">
                <div class="group_184 flex-col justify-between">
                    <div class="box_36 flex-col" >
                        <div
                                v-if="newsMainObj && newsMainObj.pic"
                                class="box36_content"
                                :style="{ backgroundImage: `url(${newsMainObj.pic})` }"
                        ></div>
                    </div>
                    <div class="box_37 flex-col justify-end">
                        <span class="text_76">{{newsMainObj.publishTime}}</span>
                        <span class="text_77" @click="goToDetail(newsMainObj)">{{newsMainObj.title}}</span>
                        <div class="text_78 clamp-2" v-html="newsMainObj.introduce" @click="goToDetail(newsMainObj)"></div>
                        <div class="image-text_270 flex-row justify-between" >
                            <span class="text-group_28" @click="goToMore('Information')">查看更多</span>
                            <img
                                    class="thumbnail_1"
                                    referrerpolicy="no-referrer"
                                    src="../../../assets/index/chpc_index.map_04.png"
                            />
                        </div>
                        <div class="box_38 flex-col"></div>
                    </div>
                </div>

                <div class="group_185 flex-col justify-between">
                    <div class="group_36 flex-col justify-end" v-for="(item, index) in newsList" :key="index" >
                        <div class="text-group_369 flex-col justify-between">
                            <span class="text_81">{{item.publishTime}}</span>
                            <span class="text_82" @click="goToDetail(item)">{{item.title}}</span>
                        </div>
                        <div class="box_40 flex-col"></div>
                    </div>

                    <div class="group_40 flex-row">
                        <div class="image-text_271 flex-row justify-between" @click="goToMore('Information')">
                            <span class="text-group_33">查看更多</span>
                            <img
                                    class="thumbnail_2"
                                    referrerpolicy="no-referrer"
                                    src="../../../assets/index/chpc_index.map_04.png"
                            />
                        </div>
                    </div>
                    <div class="group_41 flex-col"></div>
                </div>
            </div>

        </div>

        <div class="group_186 flex-col">
            <div class="box_43 flex-row justify-between">
                <img
                        class="image_22"
                        referrerpolicy="no-referrer"
                        src="../../../assets/index/chpc_index.map.png"
                />
                <div class="block_97 flex-col">
                    <span class="text_87">遍布全国的办事处</span>
                    <div class="image-text_272 flex-row justify-between">
                        <img
                                class="label_10"
                                referrerpolicy="no-referrer"
                                src="../../../assets/index/chpc_index_local.png"
                        />
                        <span class="text-group_34">北京总公司</span>
                    </div>
                    <span class="paragraph_10">
            北京市朝阳区建国路93号院万达广场8号楼2606室
            <br />
            Room&nbsp;2606,Block&nbsp;8,Wanda&nbsp;Plaza,No.93&nbsp;Jianguo&nbsp;Road,Chaoyang&nbsp;District,Beijing&nbsp;100022,P.R.China
          </span>
                    <span class="text_88">电话: 010-58204887，传真: 010-58204839</span>
                    <div class="image-text_273 flex-row justify-between">
                        <img
                                class="label_11"
                                referrerpolicy="no-referrer"
                                src="../../../assets/index/chpc_index_local.png"
                        />
                        <div class="text-group_372 flex-col">
                            <span class="text_89">上海分公司</span>
                            <span class="paragraph_11">
                上海市黄浦区蒙自路757号平安滨江金融中心30层3001室
                <br />
                Suite&nbsp;3001,&nbsp;30/F,&nbsp;Ping&nbsp;An&nbsp;Binjiang&nbsp;Financial&nbsp;Center,&nbsp;No.&nbsp;757&nbsp;Mengzi&nbsp;Road,&nbsp;Huangpu&nbsp;District,&nbsp;Shanghai&nbsp;200023,&nbsp;P.R.China
              </span>
                            <span class="text_90">电话: 021-63331086</span>
                        </div>
                    </div>
                    <div class="image-text_274 flex-row justify-between">
                        <img
                                class="label_12"
                                referrerpolicy="no-referrer"
                                src="../../../assets/index/chpc_index_local.png"
                        />
                        <div class="text-group_373 flex-col justify-between">
                            <span class="text_91">各地办事处</span>
                            <span class="text_92">
                武汉&nbsp;•&nbsp;广州&nbsp;•&nbsp;南京&nbsp;•&nbsp;成都&nbsp;•&nbsp;天津&nbsp;•&nbsp;合肥&nbsp;•&nbsp;无锡&nbsp;•&nbsp;西安
              </span>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>
<script>

    import {formartDate} from "../../../common/testFun";
    export default {
        props: {
            datalist: {
                type: Object,
                required: true
            },
        },
        data() {
            return {
                serverCount: [0, 0, 0, 0, 0, 0, 0, 0], // 初始值设为0
                targetValues: [20, 30, 100, 300, 900, 7000, 8000, 590], // 目标值
                hasAnimated: false, // 防止重复触发
                loopData0: [
                    {
                        lanhuBg0: 'rgba(27,71,93,1.000000)',
                        lanhuimage0: require('../../../assets/home/home_core_icon_01.png'),
                        lanhutext0: 'C',
                        lanhutext1: 'hannel',
                        lanhutext2: '渠道风控管理',
                        detailInfo:'作为医药领域渠道风控与合规管理服务的先行者之一，我们提供从常规核查到深度核查的创新风控管理解决方案，覆盖企业内部人员、经销商、药店及医院等多渠道多管理环节，助力客户破解渠道管理中的核心痛点。通过彻查问题并建立监督制约机制，提升销售数据的真实性和准确性，改善营销决策的有效性，优化渠道管理绩效，助力企业实现高效、透明的渠道运营与管理。',
                        isHovered: false,
                        //lanhuBg3: require('../../../assets/home/home_core_bnt_bj.png'),
                        lanhutext3: '查看⽅案',
                        lanhuimage1: require('../../../assets/home/home_core_icon_bj.png'),
                    },
                    {
                        lanhuBg0: 'rgba(17,110,130,1.000000)',
                        lanhuimage0: require('../../../assets/home/home_core_icon_02.png'),
                        lanhutext0: 'C',
                        lanhutext1: 'ompliance',
                        lanhutext2: '业务合规管理',
                        detailInfo:'面对医药大健康行业日益复杂的监管环境与多元化营销场景，康柏汉森为企业提供全链条、多维度的合规风控解决方案，覆盖费用审核、活动核查、合规审核等关键场景。支持全国范围内的突击核查，定制化风控核查的需求，助力客户降低合规风险、从容应对政策高压与市场挑战。',
                        isHovered: false,
                        //lanhuBg3: require('../../../assets/home/home_core_bnt_bj.png'),
                        lanhutext3: '查看⽅案',
                        lanhuimage1: require('../../../assets/home/home_core_icon_bj.png'),
                    },
                    {
                        lanhuBg0: 'rgba(0,120,126,1.000000)',
                        lanhuimage0: require('../../../assets/home/home_core_icon_03.png'),
                        lanhutext0: 'C',
                        lanhutext1: 'onsultation',
                        lanhutext2: '企业健康咨询',
                        detailInfo:'依托近二十年、100余家药械及大健康行业客户服务经验，我们为销售、商务、运营、采购、财务和内控等多部门提供全生命周期风控与企业健康咨询服务。通过日益积累的行业洞察与风险防控经验，帮助厘清运营规则，优化风险防范与控制策略，助力企业在政策高压、竞争加剧的复杂环境中实现稳健可持续发展。',
                        isHovered: false,
                        //lanhuBg3: require('../../../assets/home/home_core_bnt_bj.png'),
                        lanhutext3: '查看⽅案',
                        lanhuimage1: require('../../../assets/home/home_core_icon_bj.png'),
                    }
                ],

                //主图新闻
                newsMainObj: {
                    pic: '',
                    publishTime: '',
                    title: '',
                    content: '',
                    introduce:'',
                },
                newsList:[],

            };
        },
        mounted() {
            // 使用 Intersection Observer 监听元素
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && !this.hasAnimated) {
                        this.startCounterAnimation();
                        this.hasAnimated = true;
                    }
                });
            });

            // 获取目标元素（给block_9添加ref）
            const targetElement = this.$refs.serviceAdvantages;
            if (targetElement) {
                observer.observe(targetElement);
            }
        },
        methods: {
            handleHover(index, isHover) {
                this.loopData0[index].isHovered = isHover
            },
            startCounterAnimation() {
                const duration = 1500; // 3秒
                const startTime = Date.now();

                const animate = () => {
                    const elapsed = Date.now() - startTime;
                    const progress = Math.min(elapsed / duration, 1);

                    this.serverCount = this.targetValues.map(target => {
                        return Math.floor(progress * target);
                    });

                    if (progress < 1) {
                        requestAnimationFrame(animate);
                    } else {
                        this.serverCount = [...this.targetValues]; // 确保最终值准确
                    }
                };

                requestAnimationFrame(animate);
            },
            // 实现两种跳转方式
            goToDetail(item) {
                // 添加防御性判断
                if (this.$route.path === '/news') return; // 阻止重复跳转

                this.$router.push({
                    path: '/news',
                    query: { id: item.id }
                }).catch(err => {
                    // 捕获路由重复跳转的异常
                    if (err.name !== 'NavigationDuplicated') {
                        console.error('Navigation error:', err);
                    }
                });

                window.scrollTo(0, 0);
            },
            goToMore(url) {
                url = '/' + url;
                this.$router.push(url, () => {
                    // 导航完成后的回调
                    window.scrollTo(0, 0)
                })
            },
        },
        watch: {
            datalist: {
                handler(newVal) {
                    let data = newVal.menuList;
                    //this.newsMainObj = newVal.main;
                    if(newVal.main){
                        this.newsMainObj = {
                            ...this.newsMainObj, // 保留原有结构
                            id:newVal.main.id,
                            pic: newVal.main.pic || '',
                            title: newVal.main.title || '',
                            content: newVal.main.content || '',
                            introduce:newVal.main.introduce || '',
                            publishTime: newVal.main.publishTime
                                ? formartDate(newVal.main.publishTime)
                                : ''
                        };
                    }
                    if(this.newsMainObj){
                        if(newVal.main && newVal.main.publishTime) {
                            let ttime =   formartDate(newVal.main.publishTime);
                            this.newsMainObj.publishTime = ttime;
                        }
                    }
                    if(newVal && newVal.newsList){
                        this.newsList = newVal.newsList.map(item=>{
                            if(item.publishTime){
                                item.publishTime  = formartDate(item.publishTime);
                            }else{
                                item.publishTim = '';
                            }
                            return item;
                        });
                    }

                },
                immediate: true
            },
        }
    };
</script>

<style scoped lang="css"  >

    .page_home_hx {
        display: flex !important;
        flex-direction: column;
        min-width: 1468px; /* 保持设计稿宽度 */
        margin: 0 auto; /* 居中显示 */
    }


    /**动态文字**/
    .text-group_19,
    .text-group_20,
    .text-group_21,
    .text-group_22,
    .text-group_23,
    .text-group_24,
    .text-group_26,
    .text_71 {
        transition: all 0.3s ease-out;
        font-variant-numeric: tabular-nums; /* 保证数字等宽 */
    }

    .box_12 {
        width: 1468px;
        background: url(../../../assets/index/chpc_home_index_hx_07.png) 100% no-repeat;
        background-size: 100% 100%;
        margin-top: -1px;
        align-items: center;
    }

    .text_30 {
        width: 300px;
        height: 53px;
        overflow-wrap: break-word;
        color: rgba(18, 20, 28, 1);
        font-size: 38px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        line-height: 53px;
        margin: 46px 0 0 0;
    }

    .text-wrapper_4 {
        width: 1108px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 20px;
        text-align: center;
        white-space: nowrap;
        line-height: 28px;
        margin: 7px 0 0 0;
    }

    .list_28 {
        margin: 35px 0 0 0;
        position: relative;
        z-index: 1;
        align-items: flex-start;
        transition: all 0.3s ease;

        display: flex !important;
        flex-direction: row !important;
        flex-wrap: nowrap !important;
        width: 100%;
        overflow-x: visible;
    }
    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .section_2 {
        position: relative;
        border-radius: 10px;
        width: 362px;
        height: 264px;
        margin-right: 57px;

        transition: height 0.3s ease;
        margin-bottom: 20px;
    }
    .list_28 .section_2:last-child {
        margin-right: 0;
    }

    .box_181 {
        width: 152px;
        height: 226px;
        margin: 19px 0 0 109px;
    }

    .image_9 {
        width: 72px;
        height: 72px;
        margin-left: 40px;
    }

    .text-wrapper_5 {
        height: 40px;
        overflow-wrap: break-word;
        font-size: 0;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        white-space: nowrap;
        line-height: 40px;


        width: 100%; /* 改为充满父容器 */
        text-align: center; /* 文字居中 */
        margin: 4px 0 0 0; /* 移除原左边距 */
    }

    .text_33 {
        width: 106px;
        height: 40px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 28px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 40px;
    }

    .text_34 {
        width: 106px;
        height: 40px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 16px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        line-height: 40px;
    }

    .text_35 {
        width: 152px;
        height: 36px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 25px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        line-height: 36px;
        margin-top: 3px;
    }

    .text-wrapper_6 {
        background: url(../../../assets/home/home_core_bnt_bj.png) 0px 0px no-repeat;
        height: 38px;
        background-size: 153px 38px;
        margin-top: 33px;
        width: 152px;
    }

    .text_36 {
        width: 64px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 16px;
        font-weight: NaN;
        text-align: center;
        white-space: nowrap;
        line-height: 22px;
        margin: 7px 0 0 44px;
    }
    .detailInfo {
        display: block;
        width: 340px;
        color: rgba(255, 255, 255, 0.9);
        font-size: 16px;
        text-align: justify;

        border-radius: 8px;
        transition: all 0.3s ease;
        white-space: normal;
        word-break: break-word;

        padding: 1.5em 2em;
        line-height: 1.8em;

        margin: 19px 0 0 -100px; /* 调整左侧负边距 */
        box-sizing: border-box; /* 确保padding不增加实际宽度 */
    }

    /* 悬停时微调效果（可选） */
    .detailInfo:hover {
        /*background: rgba(0, 0, 0, 0.2);*/
        transform: translateY(-2px);
    }

    .image_52 {


        position: absolute;
        right: 0;
        bottom: 0; /* 始终定位在底部 */
        margin: 0; /* 移除原有margin */
        width: 126px;
        height: 197px;
    }

    .image-wrapper_1 {
        background-color: rgba(255, 255, 255, 1);
        height: 534px;
        width: 1200px;
        margin: 29px 0 74px 0;

        position: relative;
        z-index: 0;
        margin-top: auto; /* 自动上边距 */
        transition: margin 0.3s ease; /* 添加过渡 */
    }

    .image_26 {
        width: 1200px;
        height: 499px;
        margin-top: 17px;
    }

    .group_179 {
        position: relative;
        width: 1468px;
        height: 1314px;
    }

    .block_3 {
        height: 634px;
        background: url(../../../assets/index/chpc_home_index_hx_06.png)
        100% no-repeat;
        background-size: 100% 100%;
        margin-top: 679px;
        width: 1468px;
    }

    .block_93 {
        width: 676px;
        height: 96px;
        margin: 60px 0 0 396px;
    }

    .text-group_356 {
        width: 676px;
        height: 96px;
    }

    .text_45 {
        width: 266px;
        height: 53px;
        overflow-wrap: break-word;
        color: rgba(18, 20, 28, 1);
        font-size: 38px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        line-height: 53px;
        margin-left: 205px;
    }

    .text_46 {
        width: 676px;
        height: 37px;
        overflow-wrap: break-word;
        color: rgba(135, 135, 135, 1);
        font-size: 26px;
        font-weight: NaN;
        text-align: center;
        white-space: nowrap;
        line-height: 37px;
        margin-top: 6px;
    }

    .block_94 {
        width: 1200px;
        height: 432px;
        margin: 45px 0 1px 134px;
    }

    .group_180 {
        width: 1200px;
        height: 432px;
    }

    .group_181 {
        width: 1200px;
        height: 216px;
        justify-content: space-evenly; /* 新增：4 个卡片水平等间距居中 */
        align-items: center;
    }

    .block_5 {
        background-color: rgba(255, 255, 255, 1);
        border-radius: 9px;
        width: 240px;
        height: 216px;
    }

    .image-text_258 {
        width: 195px;
        height: 150px;
        margin: 24px 0 0 23px;
    }

    .image_15 {
        width: 96px;
        height: 96px;
        margin-left: 50px;
    }

    .text-group_357 {
        width: 195px;
        height: 47px;
        margin-top: 7px;
    }

    .text_47 {
        width: 195px;
        height: 23px;
        overflow-wrap: break-word;
        color: rgba(46, 45, 62, 1);
        font-size: 16px;
        font-family: AlibabaPuHuiTi_3_65_Medium;
        font-weight: 500;
        text-align: center;
        white-space: nowrap;
        line-height: 23px;
    }

    .text_48 {
        width: 60px;
        height: 15px;
        overflow-wrap: break-word;
        color: rgba(144, 147, 157, 1);
        font-size: 12px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 15px;
        margin: 9px 0 0 67px;
    }

    .block_6 {
        background-color: rgba(255, 255, 255, 1);
        border-radius: 9px;
        width: 240px;
        height: 216px;
    }

    .image-text_259 {
        width: 163px;
        height: 150px;
        margin: 24px 0 0 39px;
    }

    .image_16 {
        width: 96px;
        height: 96px;
        margin-left: 33px;
    }

    .text-group_358 {
        width: 163px;
        height: 47px;
        margin-top: 7px;
    }

    .text_49 {
        width: 163px;
        height: 23px;
        overflow-wrap: break-word;
        color: rgba(46, 45, 62, 1);
        font-size: 16px;
        font-family: AlibabaPuHuiTi_3_65_Medium;
        font-weight: 500;
        text-align: center;
        white-space: nowrap;
        line-height: 23px;
    }

    .text_50 {
        width: 53px;
        height: 15px;
        overflow-wrap: break-word;
        color: rgba(144, 147, 157, 1);
        font-size: 12px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 15px;
        margin: 9px 0 0 54px;
    }

    .block_7 {
        background-color: rgba(255, 255, 255, 1);
        border-radius: 9px;
        width: 240px;
        height: 216px;
    }

    .image-text_260 {
        width: 98px;
        height: 150px;
        margin: 24px 0 0 72px;
    }

    .image-wrapper_2 {
        background-color: rgba(255, 255, 255, 1);
        border-radius: 50%;
        height: 92px;
        margin-left: 2px;
        width: 92px;
    }

    .image_17 {
        width: 54px;
        height: 56px;
        margin: 18px 0 0 19px;
    }

    .text-group_359 {
        width: 98px;
        height: 47px;
        margin-top: 11px;
    }

    .text_51 {
        width: 98px;
        height: 23px;
        overflow-wrap: break-word;
        color: rgba(46, 45, 62, 1);
        font-size: 16px;
        font-family: AlibabaPuHuiTi_3_65_Medium;
        font-weight: 500;
        text-align: center;
        white-space: nowrap;
        line-height: 23px;
    }

    .text_52 {
        width: 68px;
        height: 15px;
        overflow-wrap: break-word;
        color: rgba(144, 147, 157, 1);
        font-size: 12px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 15px;
        margin: 9px 0 0 14px;
    }

    .box_19 {
        background-color: rgba(255, 255, 255, 1);
        border-radius: 9px;
        width: 240px;
        height: 216px;
    }

    .image-text_261 {
        width: 114px;
        height: 149px;
        margin: 24px 0 0 63px;
    }

    .image-wrapper_4 {
        background-color: rgba(255, 255, 255, 1);
        border-radius: 50%;
        height: 92px;
        margin-left: 10px;
        width: 92px;
    }

    .image_20 {
        width: 56px;
        height: 56px;
        margin: 21px 0 0 19px;
    }

    .text-group_360 {
        width: 240px;                    /* 与卡片同宽 */
        height: 46px;
        margin-top: 11px;
        margin-left: -63px;              /* 抵消父容器 margin-left:63px，使左边缘对齐卡片左边缘 */
        align-items: center;             /* flex-col 交叉轴居中 */
    }

    .text_56 {
        width: auto;
        height: 23px;
        overflow-wrap: break-word;
        color: rgba(46, 45, 62, 1);
        font-size: 16px;
        font-family: AlibabaPuHuiTi_3_65_Medium;
        font-weight: 500;
        text-align: center;
        white-space: nowrap;
        line-height: 23px;
    }

    .text-wrapper_11 {
        width: auto;
        height: 15px;
        overflow-wrap: break-word;
        color: rgba(144, 147, 157, 1);
        font-size: 12px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        font-weight: NaN;
        text-align: center;
        white-space: nowrap;
        line-height: 15px;
        margin: 8px 0 0 0;
    }

    .group_182 {
        width: 721px;
        height: 216px;
        margin-left: 239px;
    }

    .group_25 {
        background-color: rgba(255, 255, 255, 1);
        border-radius: 9px;
        width: 240px;
        height: 216px;
    }

    .image_18 {
        width: 95px;
        height: 84px;
        margin: 34px 0 0 72px;
    }

    .text-group_361 {
        width: 100%;                 /* 占满卡片宽度，使文字在卡片内居中 */
        height: 47px;
        margin: 12px 0 39px;         /* 去掉左侧固定边距 */
        align-items: center;         /* 子元素水平居中（flex-col 的交叉轴） */
    }

    .text_53 {
        width: auto;
        height: 23px;
        overflow-wrap: break-word;
        color: rgba(46, 45, 62, 1);
        font-size: 16px;
        font-family: AlibabaPuHuiTi_3_65_Medium;
        font-weight: 500;
        text-align: center;
        white-space: nowrap;
        line-height: 23px;
    }

    .text_54 {
        width: auto;
        height: 15px;
        overflow-wrap: break-word;
        color: rgba(144, 147, 157, 1);
        font-size: 12px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        font-weight: NaN;
        text-align: center;
        white-space: nowrap;
        line-height: 15px;
    }

    .group_26 {
        background-color: rgba(255, 255, 255, 1);
        border-radius: 9px;
        width: 240px;
        height: 216px;
    }

    .image-wrapper_3 {
        background-color: rgba(255, 255, 255, 1);
        border-radius: 50%;
        height: 92px;
        width: 92px;
        margin: 29px 0 0 73px;
    }

    .image_19 {
        width: 58px;
        height: 45px;
        margin: 24px 0 0 18px;
    }

    .text-group_362 {
        width: 130px;
        height: 62px;
        margin: 9px 0 24px 55px;
    }

    .text_55 {
        width: 130px;
        height: 23px;
        overflow-wrap: break-word;
        color: rgba(46, 45, 62, 1);
        font-size: 16px;
        font-family: AlibabaPuHuiTi_3_65_Medium;
        font-weight: 500;
        text-align: center;
        white-space: nowrap;
        line-height: 23px;
    }

    .paragraph_1 {
        width: 37px;
        height: 30px;
        overflow-wrap: break-word;
        color: rgba(144, 147, 157, 1);
        font-size: 12px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        font-weight: NaN;
        text-align: center;
        line-height: 15px;
        margin: 9px 0 0 46px;
    }

    .box_20 {
        background-color: rgba(255, 255, 255, 1);
        border-radius: 9px;
        width: 240px;
        height: 216px;
        margin-left: 1px;
    }

    .image_43 {
        width: 92px;
        height: 92px;
        margin: 29px 0 0 74px;
    }

    .text-group_363 {
        width: 179px;
        height: 47px;
        margin: 9px 0 39px 30px;
    }

    .text_59 {
        width: 179px;
        height: 23px;
        overflow-wrap: break-word;
        color: rgba(46, 45, 62, 1);
        font-size: 16px;
        font-family: AlibabaPuHuiTi_3_65_Medium;
        font-weight: 500;
        text-align: center;
        white-space: nowrap;
        line-height: 23px;
    }

    .text_60 {
        width: 83px;
        height: 15px;
        overflow-wrap: break-word;
        color: rgba(144, 147, 157, 1);
        font-size: 12px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        font-weight: NaN;
        text-align: center;
        white-space: nowrap;
        line-height: 15px;
        margin: 9px 0 0 48px;
    }

    .box_22 {
        background-color: rgba(255, 255, 255, 1);
        border-radius: 9px;
        width: 240px;
        height: 216px;
        margin-top: 2px;
    }

    .image_21 {
        width: 80px;
        height: 45px;
        margin: 53px 0 0 80px;
    }

    .text-group_364 {
        width: 153px;
        height: 47px;
        margin: 32px 0 39px 44px;
    }

    .text_61 {
        width: 153px;
        height: 23px;
        overflow-wrap: break-word;
        color: rgba(46, 45, 62, 1);
        font-size: 16px;
        font-family: AlibabaPuHuiTi_3_65_Medium;
        font-weight: 500;
        text-align: center;
        white-space: nowrap;
        line-height: 23px;
    }

    .text_62 {
        width: 27px;
        height: 15px;
        overflow-wrap: break-word;
        color: rgba(144, 147, 157, 1);
        font-size: 12px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 15px;
        margin: 9px 0 0 63px;
    }

    .block_9 {
        position: absolute;
        left: 0;
        top: -14px;
        width: 1468px;
        height: 690px;
        background: url(../../../assets/index/chpc_home_index_003.png)
        100% no-repeat;
        background-size: 100% 100%;
    }

    .text-group_365 {
        width: 294px;
        height: 89px;
        margin: 281px 0 0 134px;
    }

    .text_63 {
        width: 152px;
        height: 53px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 38px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        line-height: 53px;
    }

    .text_64 {
        width: 294px;
        height: 30px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 26px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        font-weight: NaN;
        text-align: center;
        white-space: nowrap;
        line-height: 31px;
        margin-top: 6px;
    }

    .box_23 {
        width: 803px;
        height: 498px;
        background: url(../../../assets/index/chpc_home_index_hx_02.png)
        100% no-repeat;
        background-size: 100% 100%;
        margin: 99px 134px 0 0;
    }

    .section_83 {
        position: relative;
        width: 682px;
        height: 162px;
        margin: 46px 0 0 73px;
    }


    .paragraph_2 {
        width: 114px;
        height: 50px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 18px;
        letter-spacing: 0.00866666715592146px;
        font-weight: NaN;
        text-align: center;
        line-height: 25px;
        margin-top: 112px;
    }

    .text_118 {
        width: 22px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 20px;
        letter-spacing: 0.00962962955236435px;
        font-weight: NaN;
        text-align: center;
        white-space: nowrap;
        line-height: 28px;
        margin: 69px 0 0 -109px;
    }

    .text_65 {
        width: 21px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 20px;
        letter-spacing: 0.00962962955236435px;
        font-weight: NaN;
        text-align: center;
        white-space: nowrap;
        line-height: 28px;
        margin: 70px 0 0 50px;
    }

    .box_25 {
        background-color: rgba(255, 255, 255, 0.28);
        width: 1px;
        height: 98px;
        margin: 40px 0 0 46px;
    }

    .paragraph_3 {
        width: 110px;
        height: 50px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 18px;
        letter-spacing: 0.00866666715592146px;
        font-weight: NaN;
        text-align: center;
        line-height: 25px;
        margin: 112px 0 0 40px;
    }

    .image-text_262 {
        width: 69px;
        height: 105px;
        margin-left: -104px;
    }

    .label_17 {
        width: 36px;
        height: 40px;
        margin-left: 33px;
    }

    .text-group_20 {
        width: 68px;
        height: 53px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 38px;
        letter-spacing: 0.018296295776963234px;
        font-family: AlibabaPuHuiTi_3_105_Heavy;
        font-weight: NaN;
        text-align: right;
        white-space: nowrap;
        line-height: 53px;
        margin-top: 12px;
    }

    .text_66 {
        width: 22px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 20px;
        letter-spacing: 0.00962962955236435px;
        font-weight: NaN;
        text-align: center;
        white-space: nowrap;
        line-height: 28px;
        margin: 70px 0 0 5px;
    }

    .box_28 {
        background-color: rgba(255, 255, 255, 0.28);
        width: 1px;
        height: 98px;
        margin: 40px 0 0 53px;
    }

    .image-text_263 {
        width: 91px;
        height: 102px;
        margin: 4px 0 0 36px;
    }

    .label_25 {
        width: 40px;
        height: 35px;
        margin-left: 33px;
    }

    .text-group_21 {
        width: 91px;
        height: 53px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 38px;
        letter-spacing: 0.018296295776963234px;
        font-family: AlibabaPuHuiTi_3_105_Heavy;
        font-weight: NaN;
        text-align: right;
        white-space: nowrap;
        line-height: 53px;
        margin-top: 14px;
    }

    .paragraph_4 {
        width: 94px;
        height: 50px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 18px;
        letter-spacing: 0.00866666715592146px;
        font-weight: NaN;
        text-align: center;
        line-height: 25px;
        margin: 112px 0 0 -74px;
    }

    .text_67 {
        width: 21px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 20px;
        letter-spacing: 0.00962962955236435px;
        font-weight: NaN;
        text-align: center;
        white-space: nowrap;
        line-height: 28px;
        margin: 70px 0 0 -12px;
    }

    .box_30 {
        background-color: rgba(255, 255, 255, 0.28);
        width: 1px;
        height: 98px;
        margin: 40px 0 0 34px;
    }

    .image-text_264 {
        width: 91px;
        height: 104px;
        margin: 1px 0 0 31px;
    }

    .label_18 {
        width: 39px;
        height: 39px;
        margin-left: 36px;
    }

    .text-group_22 {
        width: 91px;
        height: 53px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 38px;
        letter-spacing: 0.018296295776963234px;
        font-family: AlibabaPuHuiTi_3_105_Heavy;
        font-weight: NaN;
        text-align: right;
        white-space: nowrap;
        line-height: 53px;
        margin-top: 12px;
    }

    .paragraph_5 {
        width: 91px;
        height: 50px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 18px;
        letter-spacing: 0.00866666715592146px;
        font-weight: NaN;
        text-align: center;
        line-height: 25px;
        margin: 112px 0 0 -77px;
    }

    .text_68 {
        width: 21px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 20px;
        letter-spacing: 0.00962962955236435px;
        font-weight: NaN;
        text-align: center;
        white-space: nowrap;
        line-height: 28px;
        margin: 70px 0 0 -7px;
    }

    .image-text_265 {
        position: absolute;
        left: 27px;
        top: 1px;
        width: 46px;
        height: 104px;
    }

    .label_2 {
        width: 31px;
        height: 39px;
        margin-left: 13px;
    }

    .text-group_19 {
        width: 46px;
        height: 53px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 38px;
        letter-spacing: 0.018296295776963234px;
        font-family: AlibabaPuHuiTi_3_105_Heavy;
        font-weight: NaN;
        text-align: right;
        white-space: nowrap;
        line-height: 53px;
        margin-top: 12px;
    }

    .image-wrapper_21 {
        position: absolute;
        left: 40px;
        top: 0;
        width: 598px;
        height: 40px;
        justify-content: space-between;
    }

    .section_84 {
        width: 696px;
        height: 162px;
        margin: 86px 0 42px 64px;
    }

    .box_182 {
        width: 133px;
        height: 160px;
        margin-top: 1px;
    }

    .box_183 {
        width: 138px;
        height: 104px;
        margin-left: 7px;
    }

    .image-text_266 {
        width: 102px;
        height: 104px;
        margin-left: -16px;
    }

    .label_19 {
        width: 35px;
        height: 40px;
        margin-left: 42px;
    }

    .text-group_23 {
        width: 91px;
        height: 53px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 38px;
        letter-spacing: 0.018296295776963234px;
        font-family: AlibabaPuHuiTi_3_105_Heavy;
        font-weight: NaN;
        text-align: right;
        white-space: nowrap;
        line-height: 53px;
        margin-top: 11px;
    }

    .text_69 {
        width: 21px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 20px;
        letter-spacing: 0.00962962955236435px;
        font-weight: NaN;
        text-align: center;
        white-space: nowrap;
        line-height: 28px;
        margin-top: 67px;
    }

    .paragraph_6 {
        width: 133px;
        height: 50px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 18px;
        letter-spacing: 0.00866666715592146px;
        font-weight: NaN;
        text-align: center;
        line-height: 25px;
        margin-top: 6px;
    }

    .group_30 {
        background-color: rgba(255, 255, 255, 0.28);
        width: 1px;
        height: 98px;
        margin: 14px 0 0 20px;
    }

    .box_184 {
        width: 139px;
        height: 162px;
        margin-left: 27px;
    }

    .box_185 {
        width: 139px;
        height: 106px;
    }

    .image-text_267 {
        width: 114px;
        height: 106px;
    }

    .label_20 {
        width: 39px;
        height: 39px;
        margin-left: 45px;
    }

    .text-group_24 {
        width: 100px;
        height: 53px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 38px;
        letter-spacing: 0.018296295776963234px;
        font-family: AlibabaPuHuiTi_3_105_Heavy;
        font-weight: NaN;
        text-align: right;
        white-space: nowrap;
        line-height: 53px;
        margin-top: 14px;
    }

    .text_70 {
        width: 47px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 20px;
        letter-spacing: 0.00962962955236435px;
        text-align: center;
        white-space: nowrap;
        line-height: 28px;
        margin-top: 69px;
    }

    .paragraph_7 {
        width: 109px;
        height: 50px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 18px;
        letter-spacing: 0.00866666715592146px;
        font-weight: NaN;
        text-align: center;
        line-height: 25px;
        margin: 6px 0 0 13px;
    }

    .group_32 {
        background-color: rgba(255, 255, 255, 0.28);
        width: 1px;
        height: 98px;
        margin: 14px 0 0 29px;
    }

    .image-text_268 {
        width: 124px;
        height: 160px;
        margin: 1px 0 0 25px;
    }

    .label_21 {
        width: 40px;
        height: 40px;
        margin-left: 46px;
    }

    .text-group_366 {
        width: 114px;
        height: 109px;
        margin-top: 11px;
    }

    .text_71 {
        width: 114px;
        height: 53px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 38px;
        letter-spacing: 0.018296295776963234px;
        font-family: AlibabaPuHuiTi_3_105_Heavy;
        font-weight: NaN;
        text-align: right;
        white-space: nowrap;
        line-height: 53px;
    }

    .paragraph_8 {
        width: 111px;
        height: 50px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 18px;
        letter-spacing: 0.00866666715592146px;
        text-align: center;
        line-height: 25px;
        margin: 6px 0 0 -1px;
    }

    .text_72 {
        width: 42px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 20px;
        letter-spacing: 0.00962962955236435px;
        text-align: center;
        white-space: nowrap;
        line-height: 28px;
        margin: 68px 0 0 -15px;
    }

    .group_33 {
        background-color: rgba(255, 255, 255, 0.28);
        width: 1px;
        height: 98px;
        margin: 14px 0 0 14px;
    }

    .box_186 {
        width: 119px;
        height: 162px;
        margin-left: 36px;
    }

    .group_183 {
        width: 119px;
        height: 106px;
    }

    .image-text_269 {
        width: 91px;
        height: 106px;
    }

    .label_22 {
        width: 36px;
        height: 39px;
        margin-left: 37px;
    }

    .text-group_26 {
        width: 91px;
        height: 53px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 38px;
        letter-spacing: 0.018296295776963234px;
        font-family: AlibabaPuHuiTi_3_105_Heavy;
        font-weight: NaN;
        text-align: right;
        white-space: nowrap;
        line-height: 53px;
        margin-top: 14px;
    }

    .text_73 {
        width: 21px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 20px;
        letter-spacing: 0.00962962955236435px;
        font-weight: NaN;
        text-align: center;
        white-space: nowrap;
        line-height: 28px;
        margin-top: 69px;
    }

    .paragraph_9 {
        width: 110px;
        height: 50px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 18px;
        letter-spacing: 0.00866666715592146px;
        font-weight: NaN;
        text-align: center;
        line-height: 25px;
        margin-top: 6px;
    }

    .box_news_wrap {
        height: 843px;
        background: url(../../../assets/index/chpc_home_index_hx_01.png) 100% no-repeat;
        background-size: 100% 100%;
        margin-top: -1px;
        width: 1468px;
        align-items: center;
    }

    .block_95 {
        width: 100%;
        height: 89px;
        margin: 60px 0 0 0;
    }

    .text-group_367 {
        width: 100%;
        height: 89px;
        align-items: center;
    }

    .text_74 {
        width: 400px;
        height: 53px;
        overflow-wrap: break-word;
        color: rgba(18, 20, 28, 1);
        font-size: 38px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        line-height: 53px;
    }

    .text_75 {
        width: 400px;
        height: 30px;
        overflow-wrap: break-word;
        color: rgba(135, 135, 135, 1);
        font-size: 26px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        text-align: center;
        white-space: nowrap;
        line-height: 31px;
        margin-top: 6px;
    }

    .block_96 {
        width: 1200px;
        height: 566px;
        margin: 51px 0 77px 0;
    }

    .group_184 {
        width: 769px;
        height: 566px;

        overflow: hidden;
        position: relative;
    }

    .box_36 {
        width: 768px;
        height: 328px;
        border: 1px solid #979797;
        background:
                linear-gradient(90deg, #f3f3f3 25%, #e0e0e0 50%, #f3f3f3 75%) /* 加载骨架屏 */,
                no-repeat center/cover;
        position: relative;
        transition: 0.3s ease;

        overflow: hidden; /* 隐藏溢出内容 */

    }

    .box_36 .box36_content {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background:
                linear-gradient(90deg, #f3f3f3 25%, #e0e0e0 50%, #f3f3f3 75%),
                no-repeat center/cover;
        background-size: cover;
        transition: transform 0.3s ease; /* 缩放过渡 */
    }

    /* 悬停时仅缩放内容层 */
    .box_36:hover .box36_content {
        transform: scale(1.2);
    }


    /* 错误状态 */
    .box_36.error {
        /* background: #f8f9fa url('~@/assets/error-image.png') no-repeat center/30%;*/
    }

    .box_37 {
        background-color: rgba(249, 249, 251, 1);
        width: 769px;
        height: 238px;
        transition: background-color 0.3s ease;
    }
    .box_37:hover {
        background-color: rgba(255, 255, 255, 1) !important; /* 悬停时强制覆盖背景色 */
    }
    .group_36:hover {
        background-color: rgba(255, 255, 255, 1) !important; /* 悬停时强制覆盖背景色 */
    }

    /* 新闻标题 hover 效果 */
    .text_77:hover {
        color: #008683 !important;
        transition: color 0.3s ease;
    }

    /* "查看更多" 链接 hover 效果 */
    .text-group_28:hover {
        color: #008683 !important;
        transition: color 0.3s ease;
    }
    .text_82:hover {
        color: #008683 !important;
        transition: color 0.3s ease;
    }
    .text-group_33:hover {
        color: #008683 !important;
        transition: color 0.3s ease;
    }

    .text_76 {
        width: 94px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(0, 156, 134, 1);
        font-size: 16px;
        letter-spacing: 0.007703703828155994px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: right;
        white-space: nowrap;
        line-height: 22px;
        margin: 25px 0 0 21px;
    }

    .text_77 {
        width: 422px;
        height: 30px;
        overflow-wrap: break-word;
        color: rgba(0, 0, 0, 1);
        font-size: 22px;
        letter-spacing: 0.010592592880129814px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 30px;
        margin: 6px 0 0 21px;
        cursor: pointer;
    }

    .text_78 {
        width: 729px;
        height: 44px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 16px;
        letter-spacing: 0.007703703828155994px;
        font-weight: NaN;
        text-align: left;
        line-height: 22px;
        margin: 8px 0 0 21px;
        cursor: pointer;
    }
    /* 添加CSS样式 */
    .clamp-2 {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /* 限制两行 */
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 1.4; /* 根据实际字体大小调整 */
        max-height: 3em; /* 行高*行数 */
    }

    /* 可选：处理块级元素影响行高计算 */
    .clamp-2 >>> * {
        display: inline !important;
        margin: 0 !important;
        padding: 0 !important;
    }

    .image-text_270 {
        width: 70px;
        height: 20px;
        margin: 21px 0 0 24px;
    }

    .text-group_28 {
        cursor: pointer;
        width: 57px;
        height: 20px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 14px;
        letter-spacing: 0.006740740966051817px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 20px;
    }

    .thumbnail_1 {
        width: 7px;
        height: 12px;
        margin-top: 4px;
    }

    .box_38 {
        background-color: rgba(39, 161, 144, 1);
        width: 769px;
        height: 4px;
        margin-top: 58px;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .group_185 {
        width: 395px;
        height: 566px;
    }

    .group_36 {
        background-color: rgba(249, 249, 251, 1);
        width: 395px;
        height: 120px;
    }

    .group_37 {
        background-color: rgba(249, 249, 251, 1);
        width: 395px;
        height: 120px;
    }

    .text-group_369 {
        width: 343px;
        height: 59px;
        margin: 30px 0 0 24px;
    }

    .text_81 {
        width: 94px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(0, 156, 134, 1);
        font-size: 16px;
        letter-spacing: 0.007703703828155994px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: right;
        white-space: nowrap;
        line-height: 22px;
    }

    .text_82 {
        cursor: pointer;
        width: 343px;
        height: 26px;

        color: rgba(37, 37, 37, 1);
        font-size: 18px;
        letter-spacing: 0.008666666224598885px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 26px;
        margin-top: 11px;

        /* 新增省略号关键属性 */
        white-space: nowrap;         /* 强制不换行 */
        overflow: hidden;            /* 隐藏溢出内容 */
        text-overflow: ellipsis;     /* 显示省略号 */

        /* 移除冲突属性 */
        overflow-wrap: normal;       /* 移除原来的break-word */
    }



    .box_40 {
        background-color: rgba(232, 232, 232, 1);
        width: 343px;
        height: 1px;
        margin: 30px 0 0 24px;
    }

    .group_40 {
        width: 395px;
        height: 82px;
        background: url(../../../assets/index/chpc_index_news_bc.png)
        100% no-repeat;
        background-size: 100% 100%;
    }
    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .image-text_271 {
        cursor: pointer;
        width: 86px;
        height: 26px;
        margin: 28px 0 0 25px;
    }

    .text-group_33 {
        width: 73px;
        height: 26px;
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 18px;
        letter-spacing: 0.008666666224598885px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 26px;
    }

    .thumbnail_2 {
        width: 7px;
        height: 12px;
        margin-top: 7px;
    }

    .group_41 {
        background-color: rgba(39, 161, 144, 1);
        width: 395px;
        height: 4px;
    }
    .group_41 .flex-col {
        display: flex;
        flex-direction: column;
    }

    .group_186 {
        width: 1468px;
    }

    .box_43 {
        width: 1468px;
        height: 635px;
        background: url(../../../assets/index/chpc_home_main_01.png)
        100% no-repeat;
        background-size: 100% 100%;
    }
    .justify-between {
        display: flex;
        justify-content: space-between;
    }

    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .image_22 {
        width: 592px;
        height: 437px;
        margin: 78px 0 0 134px;
    }

    .block_97 {
        width: 510px;
        height: 469px;
        margin: 76px 135px 0 0;
    }
    .block_97 .flex-col {
        display: flex;
        flex-direction: column;
    }

    .text_87 {
        width: 288px;
        height: 50px;
        overflow-wrap: break-word;
        color: rgba(18, 20, 28, 1);
        font-size: 36px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 50px;
    }

    .image-text_272 {
        width: 136px;
        height: 31px;
        margin-top: 27px;
    }

    .label_10 {
        width: 22px;
        height: 30px;
        margin-top: 1px;
    }

    .text-group_34 {
        width: 100px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(18, 20, 28, 1);
        font-size: 20px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 28px;
    }

    .paragraph_10 {
        width: 484px;
        height: 66px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 16px;
        font-weight: NaN;
        text-align: left;
        line-height: 22px;
        margin: 8px 0 0 36px;
    }

    .text_88 {
        width: 336px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 16px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        text-align: left;
        white-space: nowrap;
        line-height: 22px;
        margin: 12px 0 0 37px;
    }

    .image-text_273 {
        width: 510px;
        height: 140px;
        margin-top: 26px;
    }

    .label_11 {
        width: 22px;
        height: 30px;
    }

    .text-group_372 {
        width: 474px;
        height: 139px;
        margin-top: 1px;
    }

    .text_89 {
        width: 100px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(18, 20, 28, 1);
        font-size: 20px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 28px;
    }

    .paragraph_11 {
        width: 488px;
        height: 66px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 16px;
        font-weight: NaN;
        text-align: left;
        line-height: 22px;
        margin-top: 11px;
    }

    .text_90 {
        width: 157px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 16px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        text-align: left;
        white-space: nowrap;
        line-height: 22px;
        margin: 12px 0 0 1px;
    }
    .text_88,
    .text_90 {
        display: inline-flex;
        align-items: center;
        height: 22px;          /* 保持原有高度 */
        line-height: 22px;     /* 可保留，但会被 flex 覆盖 */
        /* 若希望高度自适应，可改为 height: auto; line-height: 1.4; */
    }

    .image-text_274 {
        width: 423px;
        height: 62px;
        margin-top: 25px;
    }

    .label_12 {
        width: 22px;
        height: 30px;
    }

    .text-group_373 {
        width: 387px;
        height: 61px;
        margin-top: 1px;
    }

    .text_91 {
        width: 100px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(18, 20, 28, 1);
        font-size: 20px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 28px;
    }

    .text_92 {
        width: 387px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 16px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 22px;
        margin-top: 11px;
    }


</style>
